import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';

// ✅ Utility function to check environment variables
const getEnvironmentVariable = (key, fallback = null) => {
  const value = process.env[key];

  // Debug logging removed

  return value || fallback;
};

// ✅ Use environment variables with fallbacks
const firebaseConfig = {
  apiKey: getEnvironmentVariable(
    'REACT_APP_FIREBASE_API_KEY',
    'AIzaSyAnAtJyd_Pj9dfK90niJwAIQpmRpMzOSuw'
  ),
  authDomain: getEnvironmentVariable(
    'REACT_APP_FIREBASE_AUTH_DOMAIN',
    'pawdash-1bb29.firebaseapp.com'
  ),
  projectId: getEnvironmentVariable(
    'REACT_APP_FIREBASE_PROJECT_ID',
    'pawdash-1bb29'
  ),
  storageBucket: getEnvironmentVariable(
    'REACT_APP_FIREBASE_STORAGE_BUCKET',
    'pawdash-1bb29.firebasestorage.app'
  ),
  messagingSenderId: getEnvironmentVariable(
    'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
    '748395566065'
  ),
  appId: getEnvironmentVariable(
    'REACT_APP_FIREBASE_APP_ID',
    '1:748395566065:web:34fcc0125be35fabc1aa50'
  ),
  measurementId: getEnvironmentVariable(
    'REACT_APP_FIREBASE_MEASUREMENT_ID',
    'G-VPVKXECJHN'
  )
};

// Debug logging removed

const firebaseApp = initializeApp(firebaseConfig);

let messaging = null;
isSupported().then((supported) => {
  if (supported) {
    messaging = getMessaging(firebaseApp);
  }
});

export { messaging, isSupported };

